export const CLEANING_SKIPPED_DESCRIPTION = 'cleaning skipped';
export const ENQUIRY_PART_LEAD_TIME_MAX = 365;
